import $ from 'jquery';
import {TweenLite} from 'gsap'




var $circle = $('.circle'),
    $follow = $('.circle-one');

function moveCircle(e) {
    TweenLite.to($circle, 0.1, {
      x: e.clientX,
      y: e.clientY
  });
    TweenLite.to($follow, .5, {
      x: e.clientX,
      y: e.clientY
  });  
}

$(window).on('mousemove', moveCircle);